/* eslint-disable max-len */
const phoneNumber = '6281219414726'
const message =
  'Halo admin saya ingin %0a%0abooking dan menanyakan informasi harga ' +
  'beserta produk layanan massage yang disediakan..'
let url = `whatsapp://send?text=${message}&phone=${phoneNumber}`

export default url
